enum EntityList {
  PHARMEDIGROUP = 'PHARMEDIGROUP',
  PHARMEDINSIGHT = 'PHARMEDINSIGHT',
  PHARMEDISOUND = 'PHARMEDISOUND',
  PHARMEDISTORE = 'PHARMEDISTORE',
  PHARMEDISTOREBAG = 'PHARMEDISTOREBAG',
  PHARMEDISCHOOL = 'PHARMEDISCHOOL',
  PHARMEDICALL = 'PHARMEDICALL',
  CEGIDFLEX = 'CEGIDFLEX',
  PHARMEDICARE = 'PHARMEDICARE',
}

enum EntityBddApi {
  PHARMEDISOUND = 'sound',
  PHARMEDINSIGHT = 'insight',
  PHARMEDIGROUP = 'group',
  PHARMEDISCHOOL = 'school',
  PHARMEDISTORE = 'store',
  PHARMEDISTOREBAG = 'store_bag',
  PHARMEDICALL = 'call',
  PHARMEDICARE = 'care',
}

export const entityByBdd = Object.keys(EntityBddApi).map(entity => ({
  entity,
  bdd: EntityBddApi[entity],
}))

export enum ModuleList {
  KIBANA = 'KIBANA',
  HUBSPOT = 'HUBSPOT',
  DATABASE_PHARMACY = 'DATABASE_PHARMACY',
  EXPORT_INVOICE = 'EXPORT_INVOICE',
  WIZAPLACE = 'WIZAPLACE',
  INSIGHT_SOUND = 'INSIGHT_SOUND',
  HIPAY = 'HIPAY',
  REPRISE_DATA_ERP = 'REPRISE_DATA_ERP',
}

const urlImageEntity = [
  { img: 'pharmedisound', value: EntityList.PHARMEDISOUND },
  { img: 'pharmedinsight', value: EntityList.PHARMEDINSIGHT },
  { img: 'pharmedigroup', value: EntityList.PHARMEDIGROUP },
  { img: 'pharmedistore', value: EntityList.PHARMEDISTORE },
  // PLV : entite distincte de la centrale d'achat depuis la separation des menus
  // (routes /backoffice/store-bag/*). L'asset existe dans public/entity/.
  { img: 'pharmedistorebag', value: EntityList.PHARMEDISTOREBAG },
  { img: 'pharmedischool', value: EntityList.PHARMEDISCHOOL },
  { img: 'pharmedicall', value: EntityList.PHARMEDICALL },
  { img: 'pharmedicare', value: EntityList.PHARMEDICARE },
]

const entityDefault = EntityList.PHARMEDIGROUP

/**
 * Resolve une valeur d'entity depuis un input (query param, cookie...).
 * Accepte:
 *  - short code (sound, group, store_bag, school, ...) — voir EntityBddApi
 *  - enum value direct (PHARMEDISOUND, PHARMEDIGROUP, ...)
 * Insensible a la casse. Renvoie null si invalide.
 */
const resolveEntity = (input?: string | null): EntityList | null => {
  if (!input) return null
  const normalized = String(input).trim().toLowerCase()
  if (!normalized) return null

  const fromShort = entityByBdd.find(e => e.bdd.toLowerCase() === normalized)
  if (fromShort) return fromShort.entity as EntityList

  const upper = normalized.toUpperCase()
  if ((Object.values(EntityList) as string[]).includes(upper)) {
    return upper as EntityList
  }

  return null
}

export { EntityList, EntityBddApi, urlImageEntity, entityDefault, resolveEntity }
